import React from "react";
import "./components.css";

function Footer() {
  return (
    <div className="footer">
      <footer class="py-1 fixed-bottom" style={{ backgroundColor: "#DA291C" }}>
        <div class="container">
          <p class="m-0 text-center text-white">
            Copyright &copy; HQ Software 2024, v1.16
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
